import Keycloak from 'keycloak-js';
import { PROJECT_PATH } from '../url';
import axios from 'axios';

import { KeycloakConstants } from './ServiceConstants';
const { ID, IS_ADMIN, ROLE, LOGIN_REQUIRED, S256, BEESHEETS_APP_TOKEN } =
  KeycloakConstants;

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_REALM,
  clientId: process.env.REACT_APP_CLIENT_ID,
});

const initKeycloak = (onAuthenticatedCallback) => {
  keycloak
    .init({
      onLoad: LOGIN_REQUIRED,
      pkceMethod: S256,
      checkLoginIframe: true,
    })
    .then(async (authenticated) => {
      if (authenticated) {
        sessionStorage.setItem(
          process.env.REACT_APP_TOKEN_REFERENCE || BEESHEETS_APP_TOKEN,
          keycloak.token || 'no',
        );
        const user = await checkUserDetails();
        if (!user || !user?.data || !user?.data?.id) {
          doLogout();
        } else {
          sessionStorage.setItem('id', user.data.id);
          onAuthenticatedCallback();
        }
      } else {
        doLogin();
      }
    });
};

const clearAllLocalstorage = () => {
  sessionStorage.removeItem(process.env.REACT_APP_TOKEN_REFERENCE);
  sessionStorage.removeItem('id');
};

const doLogin = keycloak.login;

const doLogout = () => {
  sessionStorage.removeItem('warning_banner_dismissed');
  clearAllLocalstorage();
  keycloak.logout();
};

const getToken = () => keycloak.token;

const isLoggedIn = () => !!keycloak.token;

const updateToken = (successCallback) =>
  keycloak.updateToken(5).then(successCallback).catch(doLogin);

keycloak.onTokenExpired = () => {
  updateToken().then(() => {
    if (keycloak?.token) {
      sessionStorage.setItem(
        process.env.REACT_APP_TOKEN_REFERENCE || BEESHEETS_APP_TOKEN,
        keycloak.token,
      );
    }
  });
};

const getUsername = () => keycloak.tokenParsed?.preferred_username;

const getUserEmail = () => keycloak.tokenParsed?.email;

const getEmployeeId = () => keycloak.tokenParsed?.employeeId;

const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));

const getUserDetail = () => {
  return sessionStorage.getItem('id');
};

export const checkUserDetails = async () => {
  return axios
    .get(`${PROJECT_PATH}/users/email`, {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
    .catch((error) => {
      console.log(error);
    });
};

const KeycloakService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUsername,
  getUserEmail,
  getEmployeeId,
  hasRole,
  getUserDetail,
};

export default KeycloakService;
